export default {
      id: "globus-usage",
      viewBox: "0 0 393 393",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#globus",
      toString: function () {
        return this.url;
      }
    }